import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { PlayerTransactionFilters } from '../models'

import getAllPlayerTransactionsExtraReducer from '../thunks/get-all.thunk'
import getFilterOptionsExtraReducer from '../thunks/get-filter-options.thunk'
import initialState from './initial-state'

const playerTransactionsSlice = createSlice({
  name: 'playerTransaction',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setTransactionFiltersAction(
      state,
      action: PayloadAction<PlayerTransactionFilters>,
    ) {
      state.filters = action.payload
    },
    cleanTransactionsAction(state) {
      state.transactions = initialState.transactions
      state.pagination = initialState.pagination
      state.filters = initialState.filters
    },
  },
  extraReducers: (builder) => {
    getAllPlayerTransactionsExtraReducer(builder)
    getFilterOptionsExtraReducer(builder)
  },
})

export const PlayerTransactionsActions = playerTransactionsSlice.actions

export const playerTransactionsSelector = ({
  playerTransaction,
}: ApplicationState) => playerTransaction

export default playerTransactionsSlice
